import LargerHeaderWithNavLayout from '../../layouts/large-header-with-nav-layout';
import { StepBody } from '../../components/step-body';
import { BankStatementsPdfUploadContent } from './bank-statements-pdf-upload-content';
import { useFetchStateDataIfNull, useQuery } from '../../util/hooks';

export const BankStatementsPdfUploadPage = () => {
  const query = useQuery();

  const queryParamCheckoutId = query.get('checkoutId');
  useFetchStateDataIfNull(queryParamCheckoutId);

  return (
    <LargerHeaderWithNavLayout>
      <StepBody>
        <BankStatementsPdfUploadContent />
      </StepBody>
    </LargerHeaderWithNavLayout>
  );
};
